/**
 * Get a unique list of all zendesk article IDs that have been loaded into
 * `selfTroubleshotingArticles`.
 *
 * @param context
 * @returns number[]
 */
export const getZendeskArticleIds = ({ selfTroubleshootingArticles = [] }) => {
  const zendeskArticleIds = new Set()
  selfTroubleshootingArticles.forEach((article) => {
    article.articles.forEach((a) => zendeskArticleIds.add(a.id))
  })

  return Array.from(zendeskArticleIds)
}

/**
 * List of all customer issues in `selfTroubleshootingArticles`
 *
 * @param context
 * @returns string[]
 */
export const getSelfTroubleshootingCustomerIssues = ({
  selfTroubleshootingArticles = [],
}) => {
  return selfTroubleshootingArticles.map((article) => article.customerIssue)
}
